import { openPopup, closePopup } from './PopupAPI';

// 这是主入口文件，导出所有需要的API
export { openPopup, closePopup };

// 也可以将API挂载到window对象上，方便在非模块环境中使用
// 注意：现在 PopupAPI.tsx 直接将 API 挂载到 window.PopupAPI，所以这里不需要重复挂载

export default {
  openPopup,
  closePopup
};